import * as React from "react";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  AppBar,
  CircularProgress,
} from "@material-ui/core";
import {
  getComponentFromConfig,
  hasCheckList,
  checkIsCheckListAvailable,
} from "../../../Organisms/Common/GenericList/Helper/GenericList.Helper";
import { useParams } from "react-router";
import propTypes from "prop-types";
import { makeStyles, withStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "transparent",
  },
  appBar: {
    backgroundColor: "transparent",
    color: "var(--color-text-primary)",
    boxShadow: "none",
    borderBottom: "1px solid var(--total_row_boldbackground)",
    marginBottom: theme.spacing(2),
  },
  tabs: {
    "& .MuiTabs-indicator": {
      height: 3,
      borderRadius: "calc(3px * var(--app-radius-scale, 1)) calc(3px * var(--app-radius-scale, 1)) 0 0",
      backgroundColor: "var(--color-primary-main)",
    },
  },
  tab: {
    textTransform: "none",
    fontSize: "0.875rem",
    fontWeight: 500,
    minWidth: 100,
    color: "var(--color-text-secondary)",
    "&.Mui-selected": {
      color: "var(--color-primary-text)",
      fontWeight: 700,
    },
    "&:hover": {
      color: "var(--color-primary-text)",
      opacity: 1,
    },
  },
  tabPanel: {
    padding: theme.spacing(1, 0),
    color: "var(--color-text-primary)",
  },
  loader: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(8),
    color: "var(--color-primary-text)",
  },
}));

const CustomTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    fontSize: "0.875rem",
    fontWeight: 500,
    minWidth: 100,
    marginRight: theme.spacing(1),
    color: "var(--color-text-secondary)",
    "&.Mui-selected": {
      color: "var(--color-primary-text)",
      fontWeight: 700,
    },
    "&:hover": {
      color: "var(--color-primary-text)",
      opacity: 1,
    },
  },
}))(Tab);
function TabPanel(props) {
  const { children, value, index, classes, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      className={classes.tabPanel}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}
export default function M_Tabs(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [hideCheckListTabs, setHideCheckListTabs] = React.useState(true);
  const [checkListData, setCheckListData] = React.useState({});
  const [tabData, setTabData] = React.useState();
  const [isLoading, setIsLoading] = React.useState(false);
  const [tabSectionData, setTabSectionData] = React.useState([]);
  const { crmId } = useParams();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const getCheckListData = async ( ) => {
    setIsLoading(true);
    let checkListTempData = await checkIsCheckListAvailable(crmId);
    setHideCheckListTabs(!checkListTempData["hasCheckList"]);
    setCheckListData(checkListTempData);
    setValidIndex();
    setIsLoading(false);
  };
  React.useEffect(() => {
    props.tabData.map((element, index) => {
      let checkCheckList = hasCheckList(element);
      if (checkCheckList) {
        getCheckListData(index, props.tabData.length);
      }
      return;
    });
  }, []);
  React.useEffect(() => {
    setValidIndex();
    setTabSectionData(props.tabData);
  }, [props.tabData]);
  const getShowHide = (isCheckList, element) => {
    if (element && element.validate && Array.isArray(element.validate)) {
      let isHide = element.validate.join("").trim() === "";
      return isHide;
    }
    return false;
  };
  const setValidIndex = () => {
    setValue(0);
  };
  const getTabData = () => {
    let tempTabData = (
      <div className={classes.root}>
        <AppBar
          position="static"
          className={classes.appBar}
        >
          <Tabs
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            value={value}
            onChange={handleChange}
            className={classes.tabs}
            aria-label="basic tabs example"
          >
            {tabSectionData
              .filter((ele) => {
                if (ele.checklist) {
                  return !hideCheckListTabs;
                } else if (ele.label && ele.label === "Responses") {
                  return false;
                } else {
                  return true;
                }
              })
              .map((element, index) => {
                let checkCheckList = hasCheckList(element);
                return (
                  <CustomTab
                    key={index}
                    label={element.label}
                    hidden={getShowHide(checkCheckList, element)}
                    {...a11yProps(index)}
                  />
                );
              })}
          </Tabs>
        </AppBar>
        {tabSectionData
          .filter((ele) => {
            if (ele.checklist) {
              return !hideCheckListTabs;
            } else if (ele.label && ele.label === "Responses") {
              return false;
            } else {
              return true;
            }
          })
          .map((element, index) => {
            let checkCheckList = hasCheckList(element);
            return (
              <TabPanel key={index} value={value} index={index} classes={classes}>
                {getComponentFromConfig(
                  element,
                  checkCheckList ? checkListData : null,
                  props.content ? props.content : {},
                  props.reload ? props.reload : {}
                )}
              </TabPanel>
            );
          })}
      </div>
    );
    setTabData(tempTabData);
  };
  React.useEffect(getTabData, [
    hideCheckListTabs,
    checkListData,
    value,
    props.tabData,
  ]);
  return (
    <div>
      {isLoading ? (
        <div className={classes.loader}>
          <CircularProgress size={32} />
        </div>
      ) : tabData ? (
        tabData
      ) : (
        <div className={classes.loader}>
          <Typography variant="body2" color="textSecondary">Please Wait</Typography>
        </div>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: propTypes.any,
  value: propTypes.any,
  index: propTypes.any,
  reload: propTypes.func,
  classes: propTypes.object,
};
M_Tabs.propTypes = {
  tabData: propTypes.any,
  content: propTypes.object,
  reload: propTypes.func,
};
